import { render, staticRenderFns } from "./AddEditPage.vue?vue&type=template&id=3bffecb8&scoped=true&"
import script from "./AddEditPage.vue?vue&type=script&lang=js&"
export * from "./AddEditPage.vue?vue&type=script&lang=js&"
import style0 from "./AddEditPage.vue?vue&type=style&index=0&id=3bffecb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bffecb8",
  null
  
)

export default component.exports